var grayBg = "/static/a53f3dd94bdd30f8.png";

export { grayBg as default };
//# sourceMappingURL=bg.png.js.map
